import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ut_user") || "null");
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(!!localStorage.getItem("ut_token"));

  useEffect(() => {
    const token = localStorage.getItem("ut_token");
    if (!token) return;
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        localStorage.setItem("ut_user", JSON.stringify(res.data));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("ut_token", token);
    localStorage.setItem("ut_user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("ut_token");
    localStorage.removeItem("ut_user");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, login, logout, loading }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const portalPath = (role) => {
  if (role === "admin" || role === "super_admin") return "/admin";
  if (role === "recruiter") return "/recruiter";
  return "/member";
};
